import React, { useState, Fragment } from "react";
import { Link } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import {
  clearFormData,
  getFormData,
  setFormData,
} from "../../components/manager/form";
import { Col, Row, Button } from "react-bootstrap";
import { useMutation, useQuery } from "@apollo/client";
import "../../style/custom/review-order.scss";
import {
  CIS_LINK,
  NON_INTERNET_PRODUCT_TYPES_TO_SHOW,
} from "../../utils/constant";
import {
  getProductsQuery,
  getProductsResult,
} from "../../components/logic/products";
import Footer from "../../components/section/footer";
import StandardTerms from "../../components/standard-terms";
import PrivacyPolicy from "../../components/portal/privacy-policy";
import {
  getSiteInfoQuery,
  getSiteInfoResult,
  purchaseAndCreateUserMutation,
} from "../../components/logic/purchase";
import { useHistory } from "react-router-dom";

const Index = (props) => {
  const { building } = getFormData();
  return <Review cisLink={building?.cisLink || CIS_LINK} {...props} />;
};

const Review = ({ cisLink }) => {
  const { formatMessage } = useIntl();
  const data = getFormData();
  const [submittingForm, setSubmittingForm] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [acknowledgeChecked, setAcknowledgeChecked] = useState(false);
  const [tncChecked, setTncChecked] = useState(false);
  const [purchaseMutation] = useMutation(purchaseAndCreateUserMutation);
  const [showTerm, setTerm] = useState(false);
  const [showPolicy, setPolicy] = useState(false);
  const history = useHistory();

  function handleAcceptTnc(e, checked) {
    return setTncChecked(checked);
  }
  function handleAcknowledge(e, checked) {
    return setAcknowledgeChecked(checked);
  }
  const {
    selectedProduct = {},
    addons = [],
    shippingAddress,
    homeAddress = {},
    hardware,
    voucherCode,
  } = data;

  // const { selectedProduct, voucherCode, addons = [] } = data;

  const productsQuery = useQuery(getProductsQuery, {
    variables: {
      buildingCode: data.buildingCode,
      voucherCode: data.voucherCode,
      showHidden: true,
      selectedProductIds: [],
    },
  });

  const siteInfoQuery = useQuery(getSiteInfoQuery);

  if (productsQuery.loading || siteInfoQuery.loading) {
    return <React.Fragment />;
  }
  const siteInfo = getSiteInfoResult(siteInfoQuery);
  const products = getProductsResult(productsQuery);

  if (!data.selectedProduct) {
    return <div />;
  }

  const { period } = selectedProduct;

  const addOnPrice = addons.reduce((o, p) => p.value + o, 0);
  const addOnName = addons.map(({ name }) => name).at(0);
  const hasAddons = addons.length > 0;

  const setupProducts = products.filter(
    (pp) => pp.required && pp.id !== selectedProduct.id && !pp.onlyNewConnection
  );
  let newConnectionProducts = [];
  if (data?.address?.isNewConnection) {
    newConnectionProducts = products.filter(
      (pp) => pp.id !== selectedProduct.id && pp.onlyNewConnection
    );
  }

  let connectionFee = newConnectionProducts.reduce(
    (c, ncp) => c + parseFloat(ncp.value),
    0
  );
  let setupFee = setupProducts.reduce((c, ncp) => c + parseFloat(ncp.value), 0);
  const total =
    selectedProduct.value +
    connectionFee +
    setupFee +
    addons.reduce((o, p) => p.value + o, 0);
  const perMonth =
    selectedProduct.value +
    addons
      .filter((p) => NON_INTERNET_PRODUCT_TYPES_TO_SHOW.indexOf(p.type) > -1)
      .reduce((o, p) => p.value + o, 0);

  function getDescription(value) {
    let str = value;

    let desc = str.split(" ")[0];
    return desc;
  }
  const originalPerMonth =
    Math.round(
      (selectedProduct.originalValue ||
        selectedProduct.value +
          addons
            .filter(
              (p) => NON_INTERNET_PRODUCT_TYPES_TO_SHOW.indexOf(p.type) > -1
            )
            .reduce((o, p) => (p.originalValue || p.value) + o, 0)) * 100
    ) / 100;

  async function handleFinalFormSubmit() {
    debugger;
    setProcessing(true);
    try {
      setSubmittingForm(true);
      const data = getFormData();
      const {
        firstName,
        lastName,
        email,
        mobileNumber,
        mobileCountry,
        voucherCode,
        verification,
        selectedProduct,
        cardNumber,
        cardCCV,
        cardName,
        cardExpiryMonth,
        cardExpiryYear,
        countryId,
        addons,
        shippingAddress,
        homeAddress,
        hardware,
        buildingCode,
      } = data;

      const { unitNo, streetNo, address, suburb, state, postCode } =
        homeAddress;
      const ewayCryptKey = siteInfo.auEwayClientKey;
      let addresses = [];
      if (hardware) {
        addresses.push(Object.assign({ type: "Shipping" }, shippingAddress));
      }
      const variables = {
        firstName,
        lastName,
        email,
        mobileNumber,
        mobileCountry,
        unitNo,
        voucherCode,
        streetNo,
        address,
        suburb,
        state,
        postCode,
        buildingCode: "",
        verificationCode: verification,
        products: [selectedProduct, ...addons].map((p) => (p.id)),
        countryId,
        addresses,
        cardNumber: window.eCrypt.encryptValue(cardNumber, ewayCryptKey),
        cardCCV: window.eCrypt.encryptValue(cardCCV, ewayCryptKey),
        cardName: cardName,
        cardExpiry: `${cardExpiryMonth}${cardExpiryYear}`,
      };

      const response = await purchaseMutation({
        variables,
      });

      clearFormData();
      setFormData({
        response: {
          data: response.data.classMethods.User.purchaseAndCreateUser,
        },
      });
      setSubmittingForm(false);
      setProcessing(false);
      return history.push("/success");
    } catch (err) {
      console.log("ERROR >>> ", err);
      setFormData({ response: err });
      setSubmittingForm(false);
      return history.push("/fail");
    }
  }
  return (
    <>
      {showTerm && <StandardTerms onClose={() => setTerm(false)} />}
      {showPolicy && <PrivacyPolicy onClose={() => setPolicy(false)} />}
      <div className="review-page-container">
        <div className="review-landing">
          <div className="section-1">
            <Row className="vw-fs">
              <Col xs={12} md={12} className="vw-fs-section">
                <div className="review-modal">
                  <div className="review-modal-heading">{"Order Summary"}</div>
                  <div className="review-modal-body">
                    <div className="review-plan-details">
                      <div className="plan-detail-speed">
                        <p className="data-desc">
                          {" "}
                          {getDescription(selectedProduct.description)}
                        </p>
                        <p className="data-speed">{`${selectedProduct.name}`}</p>
                        <p className="data-detail">{"Unlimited Data"}</p>
                      </div>
                      <div className="plan-cost">
                        <p className="plan-price">{`$${
                          selectedProduct.originalValue
                            ? selectedProduct.originalValue
                            : selectedProduct.value
                        }`}</p>
                        {(selectedProduct || {}).voucherName && (
                          <p className="plan-voucher">
                            {`$${selectedProduct.value} ${selectedProduct.voucherName}`}
                          </p>
                        )}
                        {/* <p className="plan-deets">
                          {selectedProduct.description}
                        </p> */}
                      </div>
                    </div>

                    <div className="review-plan-addons">
                      {hasAddons ? (
                        <>
                          <div className="add-static-container">
                            <p className="static-span">{"Add on:"}</p>
                            <p className="static-name">{`${addOnName}`}</p>
                          </div>
                          <div className="static-details">
                            <p className="static-cost">{`$${addOnPrice}`}</p>
                          </div>
                        </>
                      ) : (
                        <></>
                      )}

                      {connectionFee > 0 && (
                        <Row className="totals justify-content-center align-items-center">
                          <Col xs={12}>
                            <div className="header">
                              {"New Developments Charge (Once off)"}
                            </div>
                          </Col>
                          <Col xs={12}>
                            <div className="value">{`$${connectionFee}`}</div>
                          </Col>
                        </Row>
                      )}
                    </div>

                    <hr />
                    <Row>
                      <Col lg={4} className={"col-display"}>
                        <div className={"label"}>
                          <FormattedMessage id={"register.final.name"} />
                          <span className="edit">
                            <Link to="/user">
                              {" ("}
                              <FormattedMessage id={"register.final.edit"} />
                              {")"}
                            </Link>
                          </span>
                        </div>
                        <span className={"value"}>
                          {`${data.firstName} ${data.lastName}`}
                        </span>
                      </Col>
                      <Col lg={5} className={"col-display"}>
                        <div className={"label"}>
                          <FormattedMessage id={"register.final.email"} />
                          <span className="edit">
                            <Link to="/user">
                              {" ("}
                              <FormattedMessage id={"register.final.edit"} />
                              {")"}
                            </Link>
                          </span>
                        </div>
                        <span className={"value"}>{`${data.email}`}</span>
                      </Col>
                    </Row>
                    <hr />
                    <Row>
                      <Col lg={4} className={"col-display"}>
                        <div className={"label"}>
                          <FormattedMessage
                            id={"register.final.mobileNumber"}
                          />
                          <span className="edit">
                            <Link to="/user">
                              {" ("}
                              <FormattedMessage id={"register.final.edit"} />
                              {")"}
                            </Link>
                          </span>
                        </div>
                        <span className={"value"}>{data.mobileNumber}</span>
                      </Col>
                      {homeAddress && (
                        <Col lg={8} className={"col-display"}>
                          <div className={"label"}>
                            <FormattedMessage id={"register.final.address"} />
                            <span className="edit">
                              <Link to="/user">
                                {" ("}
                                <FormattedMessage id={"register.final.edit"} />
                                {")"}
                              </Link>
                            </span>
                          </div>
                          <span className={"value"}>
                            {`${
                              homeAddress.unitNo ? homeAddress.unitNo + "/" : ""
                            }${homeAddress.streetNo || ""} ${
                              homeAddress.address || ""
                            }, ${homeAddress.suburb || ""}, ${
                              homeAddress.state || ""
                            }, ${
                              (homeAddress.countryData || {}).name ||
                              "Australia"
                            }, ${homeAddress.postCode || ""}`}
                          </span>
                        </Col>
                      )}
                    </Row>
                    <hr />

                    {shippingAddress && hardware && (
                      <React.Fragment>
                        <Row>
                          <Col lg={12} className={"col-display"}>
                            <div className={"label"}>
                              <FormattedMessage
                                id={"register.final.shipping-address"}
                              />
                              <span className="edit">
                                <Link to="/user">
                                  {" ("}
                                  <FormattedMessage
                                    id={"register.final.edit"}
                                  />
                                  {")"}
                                </Link>
                              </span>
                            </div>
                            <span className={"value"}>
                              {`${
                                shippingAddress.unitNo
                                  ? shippingAddress.unitNo + "/"
                                  : ""
                              }${shippingAddress.streetNo || ""} ${
                                shippingAddress.address || ""
                              }, ${shippingAddress.suburb || ""}, ${
                                shippingAddress.state || ""
                              }, ${
                                (shippingAddress.countryData || {}).name ||
                                "Australia"
                              }, ${shippingAddress.postCode || ""}`}
                            </span>
                          </Col>
                        </Row>
                        <hr />
                      </React.Fragment>
                    )}
                    {data.cardNumber && (
                      <React.Fragment>
                        <Row>
                          <Col lg={4} className={"col-display"}>
                            <div className={"label"}>
                              <FormattedMessage
                                id={"register.final.cardNumber"}
                              />
                              <span className="edit">
                                <Link to="/user">
                                  {" ("}
                                  <FormattedMessage
                                    id={"register.final.edit"}
                                  />
                                  {")"}
                                </Link>
                              </span>
                            </div>
                            <span className={"value"}>
                              {`XXXX XXXX XXXX ${data.cardNumber.substring(
                                12,
                                data.cardNumber.length
                              )}`}
                            </span>
                          </Col>
                          <Col lg={4} className={"col-display"}>
                            <div className={"label"}>
                              <FormattedMessage
                                id={"register.final.cardName"}
                              />
                              <span className="edit">
                                <Link to="/user">
                                  {" ("}
                                  <FormattedMessage
                                    id={"register.final.edit"}
                                  />
                                  {")"}
                                </Link>
                              </span>
                            </div>
                            <span
                              className={"value"}
                            >{`${data.cardName}`}</span>
                          </Col>
                          <Col lg={2} className={"col-display"}>
                            <div className={"label"}>
                              <FormattedMessage
                                id={"register.final.cardExpiry"}
                              />
                              <span className="edit">
                                <Link to="/user">
                                  {" ("}
                                  <FormattedMessage
                                    id={"register.final.edit"}
                                  />
                                  {")"}
                                </Link>
                              </span>
                            </div>
                            <span className={"value"}>
                              {`${data.cardExpiryMonth}/${data.cardExpiryYear}`}
                            </span>
                          </Col>
                          <Col lg={2} className={"col-display"}>
                            <div className={"label"}>
                              <FormattedMessage id={"register.final.cardCCV"} />
                              <span className="edit">
                                <Link to="/user">
                                  {" ("}
                                  <FormattedMessage
                                    id={"register.final.edit"}
                                  />
                                  {")"}
                                </Link>
                              </span>
                            </div>
                            <span className={"value"}>{"XXX"}</span>
                          </Col>
                        </Row>
                        <hr />
                      </React.Fragment>
                    )}
                    <div className="review-plan-summary">
                      <p className="plan-label">{"Total"}</p>

                      <div className="plan-total-summary">
                        {total !== perMonth ? (
                          <p className="summary-cost">{`$${total}`}</p>
                        ) : (
                          <p className="summary-cost">{`$${perMonth}/Month`}</p>
                        )}
                      </div>
                    </div>

                    {selectedProduct.voucherUses > 0 ? (
                      <Row>
                        <Col xs={12}>
                          <div className="change">
                            <div>
                              {`Voucher applies for ${
                                selectedProduct.voucherUses
                              } ${period.split(" ")[1].toLowerCase()}`}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    ) : undefined}

                    <FormattedMessage
                      id="register.review.total"
                      values={{
                        value: `${total}`,
                        renewal: formatMessage({
                          id: `register.products.renewal.${period
                            .split(" ")[1]
                            .toLowerCase()}`,
                        }),
                      }}
                    />
                    <Row>
                      <Col xs={12}>
                        <div className="vw-checkbox">
                          <Col xs="auto p-0">
                            <i
                              onClick={(e) =>
                                handleAcknowledge(e, !acknowledgeChecked)
                              }
                              style={{ fontSize: 35 }}
                              className={`mr-2 ${
                                acknowledgeChecked
                                  ? "far fa-check-square"
                                  : "far fa-square"
                              }`}
                            />
                          </Col>
                          <Col className="p-0">
                            {(() => {
                              let ack = "";
                              if (connectionFee > 0) {
                                ack += `I acknowledge I will be charged $${connectionFee} for the New Developments Charge in the first month in addition to my plan charge/s. `;
                              }
                              if (
                                selectedProduct.voucherName &&
                                selectedProduct.voucherUses > 1
                              ) {
                                ack += `I acknowledge that I will be charged plan charges of $${perMonth} per month for the first ${
                                  selectedProduct.voucherUses
                                } month/s and then $${originalPerMonth} per month, until cancelled. (First month: $${total}, next ${
                                  selectedProduct.voucherUses - 1
                                } month/s: $${perMonth}, thereafter: $${originalPerMonth})`;
                              } else if (
                                selectedProduct.voucherName &&
                                selectedProduct.voucherUses === 1
                              ) {
                                ack += `I acknowledge that I will be charged plan charges of $${perMonth} per month for the first month and then $${originalPerMonth} per month, until cancelled. (First month: $${total}, thereafter: $${originalPerMonth})`;
                              } else {
                                ack += `I acknowledge that I will be charged plan charges of $${perMonth} per month, until cancelled. (First month: $${total}, thereafter: $${originalPerMonth})`;
                              }
                              return ack;
                            })()}
                          </Col>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <div className="vw-checkbox tncs-link">
                          <i
                            onClick={(e) => handleAcceptTnc(e, !tncChecked)}
                            style={{ fontSize: 35 }}
                            className={`mr-2 ${
                              tncChecked
                                ? "far fa-check-square"
                                : "far fa-square"
                            }`}
                          />
                          <FormattedMessage
                            id={"register.final.accepttncs.line1"}
                            values={{
                              tnclink: (
                                <a
                                  href="https://www.superloop.com/terms"
                                  target="_blank"
                                  className="mx-1"
                                >
                                  <FormattedMessage
                                    id={"register.final.accepttncs.tnc"}
                                  />
                                </a>
                              ),
                              criticallink: (
                                <a
                                  href={
                                    cisLink ? cisLink : CIS_LINK || "https://www.superloop.com/terms"
                                  }
                                  target={"_blank"}
                                  className="mx-1"
                                >
                                  <FormattedMessage
                                    id={"register.final.accepttncs.critical"}
                                  />
                                </a>
                              ),
                              value: selectedProduct.value || "0",
                              renewal: formatMessage({
                                id: "register.products.renewal.month",
                              }),
                            }}
                          />
                        </div>
                      </Col>
                    </Row>
                    <div className="summary-actions">
                      {processing ? (
                        <div className="rotating-loader-small" />
                      ) : (
                        <Button
                          onClick={handleFinalFormSubmit}
                          disabled={
                            !(tncChecked && acknowledgeChecked) ||
                            submittingForm
                          }
                          className="confirm-proceed"
                        >
                          {"Confirm"}
                        </Button>
                      )}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          <Footer setTerm={setTerm} setPolicy={setPolicy} />
        </div>
      </div>
    </>
  );
};

export default Index;
